/**
 * Json menu
 */

if (!customElements.get('tpt-menu-json')) {
	customElements.define(
		'tpt-menu-json',
		class TptMenuJson extends HTMLElement {
			constructor() {
				super();

				if (this.querySelector('[data-json]')) {
					const jsonString = this.querySelector('[data-json]').innerHTML;
					const jsonMenu = JSON.parse(jsonString);
					const jsonMenuContent = this.querySelector('[data-json-content]');

					jsonMenu.forEach((menu, index) => {
						//console.log(menu);

						if (!menu.links) {
							const menuItem = `
							<div class="tpt-menu-item">
								<div class="tpt-menu-item__title">
									<a href="${menu.url}">${menu.title}</a>
								</div>
							</div>
							`;

							jsonMenuContent.insertAdjacentHTML('beforeend', menuItem);
						} else {
							const menuItem = `
							<div class="tpt-menu-item" data-menu-item-index="${index}">
								<div class="tpt-menu-item__title">
									<a href="${menu.url}">${menu.title}</a>
									<tpt-menu-toggle class="tpt-menu-item__toggle">
										<svg class="svgicon">
											<use href="#chevron_right"></use>
										</svg>
									</tpt-menu-toggle>
								</div>

								<ul class="tpt-menu-item__subcat"></ul>
							</div>
							`;

							jsonMenuContent.insertAdjacentHTML('beforeend', menuItem);

							const menuItemContainer = jsonMenuContent.querySelector(`[data-menu-item-index="${index}"]`);
							const subMenu = menu.links;

							subMenu.forEach((subcat) => {
								const subcatItem = `
								<li class="tpt-menu-item__subcat-item">
									<a href="${subcat.url}">${subcat.title}</a>
								</li>
								`;

								menuItemContainer.querySelector('.tpt-menu-item__subcat').insertAdjacentHTML('beforeend', subcatItem);
							});
						}
					});
				}
			}
		}
	);
}

if (!customElements.get('tpt-menu-toggle')) {
	customElements.define(
		'tpt-menu-toggle',
		class TptMenuToggle extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.toggleSubCategory);
			}

			toggleSubCategory() {
				this.closest('.tpt-menu-item').classList.toggle('active');
			}
		}
	);
}
/**
 * Update qty mobile - sticky bottom
 */

function updateQtyMobile() {
	let qtyCart = '0';

	if (document.querySelector('.mobile-cart .cart-count-bubble')) {
		qtyCart = document.querySelector('.cart-count-bubble span:first-child').innerText;
	}

	if (document.querySelector('.bottom-mobile_items .cart-count-bubble span')) {
		document.querySelector('.bottom-mobile_items .cart-count-bubble span').innerHTML = qtyCart;
	}
}

/**
 * get height header
 */
function getHeaderHeight() {
	const headerHeight = document.querySelector('.tpt-header-group').offsetHeight;
	document.querySelector('.tpt-header-group').style = '--header-height: ' + headerHeight + 'px';
}

function bodyMaxWidth() {
	const documentWidth = document.documentElement.clientWidth;
	const styleString = '--document-width:' + documentWidth + 'px';

	document.body.setAttribute('style', styleString);
}

window.addEventListener('resize', function () {
	setTimeout(() => {
		bodyMaxWidth();
		getHeaderHeight();
	}, 1000);
});

window.addEventListener('DOMContentLoaded', function () {
	bodyMaxWidth();
	getHeaderHeight();
	moveSizeChartToBody();

	/**
	 * Toogle block footer
	 */

	const blockFooterHeading = document.querySelectorAll('.footer-block .footer-block_heading');

	blockFooterHeading.forEach((item) => {
		item.addEventListener('click', () => {
			item.closest('.footer-block').classList.toggle('active');
		});
	});

	/**
	 * Toogle category mobile
	 */

	const itemCatParent = document.querySelectorAll('.mobile-parent__item');
	itemCatParent.forEach((item) => {
		item.addEventListener('click', () => {
			item.closest('.megamenu-category-item').classList.toggle('active');
		});
	});
});

/**
 * Change form customer sidebar
 */
document.querySelectorAll('.change-form-customer').forEach((element) => {
	element.addEventListener('click', (event) => changeFormCustomer(event, element));
});

function changeFormCustomer(event, element) {
	event.preventDefault();
	const modalTitle = element.getAttribute('data-form-title');
	const modalTarget = element.getAttribute('data-form-customer-target');
	const currentModal = element.closest('tpt-modal-content');
	const formCustomers = currentModal.querySelectorAll('.customer-form');

	currentModal.querySelector('.modal-title').innerHTML = modalTitle;

	formCustomers.forEach((form) => {
		form.style.display = 'none';
	});

	document.getElementById(modalTarget).style.display = 'block';
	document.getElementById(modalTarget).focus();
}

/**
 * Section lady load
 */
function secsionLadyLoad() {
	let parentSection = '';
	const section = document.querySelector('[data-ladyload="true"]');

	if (section) {
		parentSection = section.closest('.shopify-section');
	}

	if (section) {
		const elementId = section.getAttribute('id');
		const sectionId = elementId.substring(16);
		const urlFetchSectionId = window.Shopify.routes.root + '?section_id=' + sectionId;

		if (!section.classList.contains('loaded')) {
			section.classList.add('loaded');

			fetch(urlFetchSectionId)
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					setTimeout(() => {
						sectionElement = responseHTML.querySelector('section[id^="shopify-section-"]');

						section.innerHTML = sectionElement.innerHTML;
						section.querySelectorAll('script').forEach((oldScriptTag) => {
							const newScriptTag = document.createElement('script');
							Array.from(oldScriptTag.attributes).forEach((attribute) => {
								newScriptTag.setAttribute(attribute.name, attribute.value);
							});
							newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
							oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
						});

						section.setAttribute('data-ladyload', 'false');

						/**
						 * Fix lazyload image with RTL layout
						 */
						if (parentSection && document.querySelector('body').classList.contains('layout-rtl')) {
							const imagesLazy = parentSection.querySelectorAll('img');

							imagesLazy.forEach((image) => {
								if (image.getAttribute('loading') == 'lazy') {
									image.setAttribute('loading', 'loaded');
								}
							});
						}
					}, 50);
				})
				.finally(() => {
					if (document.querySelector('[data-fancybox]')) {
						Fancybox.bind('[data-fancybox="gallery"]', {});
					}
				});
		}
	}
}

let defaultDocumentTop = 0;

document.addEventListener('scroll', (event) => {
	secsionLadyLoad();
});

/**
 * Fix image lazyload with swipper slider and RTL layout
 */

const interSection = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0) {
			entry.target.querySelectorAll('img').forEach((image) => {
				if (image.getAttribute('loading') == 'lazy') {
					image.setAttribute('loading', 'loaded');
				}
			});
		}
	});
});

if (document.querySelector('body').classList.contains('layout-rtl')) {
	const swiperSlider = document.querySelectorAll('tpt-slider-component');

	swiperSlider.forEach((slider) => {
		interSection.observe(slider);
	});
}

/**
 * End fix image lazyload with swipper slider
 */

/**
 * Dropdown megamenu mobile
 */

class DropdownMegamenuMobile extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.showDropdownMegamenuMobile.bind(this));
	}

	showDropdownMegamenuMobile() {
		const btnDropdown = this;
		const menuItem = btnDropdown.closest('.menu-item');
		menuItem.classList.add('show-dropdown');

		setTimeout(function () {
			menuItem.classList.add('animate');
		}, 10);
	}
}

customElements.define('dropdown-megamenu-item', DropdownMegamenuMobile);

class BackDropdownMegamenu extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.backToMegamenuItem.bind(this));
	}

	backToMegamenuItem() {
		const btnBack = this;
		const menuItem = btnBack.closest('.menu-item');
		menuItem.classList.remove('animate');

		setTimeout(function () {
			menuItem.classList.remove('show-dropdown');
		}, 300);
	}
}

customElements.define('back-to-item', BackDropdownMegamenu);

/**
 * Sticky product add to cart
 */
class StickyProductAddToCart extends HTMLElement {
	constructor() {
		super();

		const btnChangeQty = this.querySelectorAll('.quantity__button');
		const btnStickyAddCart = this.querySelector('.sticky-add-cart');

		btnStickyAddCart.addEventListener('click', this.addToCart);

		btnChangeQty.forEach((btn) => {
			btn.addEventListener('click', this.changeQty);
		});
	}

	changeQty() {
		const inputQty = this.closest('tpt-quantity-input').querySelector('[name="quantity"]');
		const mainInput = document.querySelector('product-info quantity-input [name="quantity"]');
		let stickyInputValue = parseInt(inputQty.value);

		if (this.getAttribute('name') == 'plus') {
			stickyInputValue = stickyInputValue + 1;
		} else {
			if (parseInt(inputQty.value) > 1) {
				stickyInputValue = stickyInputValue - 1;
			}
		}

		inputQty.value = stickyInputValue;
		mainInput.value = stickyInputValue;
	}

	addToCart() {
		this.classList.add('loading');
		document.querySelector('product-info product-form .product-form__submit').click();
	}
}

customElements.define('tpt-quantity-input', StickyProductAddToCart);

function showStickyAddCart() {
	let offsetTop = document.querySelector('product-info product-form').offsetTop;
	let documentTop = document.documentElement.scrollTop;
	const stickyAddCart = document.querySelector('.sticky-button-cart');

	if (documentTop > offsetTop + 400) {
		stickyAddCart.classList.add('active');
		document.body.classList.add('show-sticky-add-cart');
	} else {
		stickyAddCart.classList.remove('active');
		document.body.classList.remove('show-sticky-add-cart');
	}
}

document.addEventListener('scroll', (event) => {
	if (document.querySelector('.sticky-button-cart')) {
		showStickyAddCart();
	}
});

/**
 * Move modal sizechart to body
 */

function moveSizeChartToBody() {
	if (document.querySelector('[id="modal-size-chart"]')) {
		document.body.append(document.querySelector('[id="modal-size-chart"]'));
	}
}

/**
 * Back to top
 */

function toTop() {
	window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.addEventListener('scroll', (event) => {
	const backToTop = document.querySelector('tpt-back-to-top');

	if (backToTop) {
		if (this.scrollY > 800) {
			backToTop.classList.add('active');
		} else {
			backToTop.classList.remove('active');
		}
	}
});

class BackToTop extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', toTop);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			toTop();
		}
	}
}

customElements.define('tpt-back-to-top', BackToTop);

/**
 * Sticky header
 */

let offsetTopHeader = 0;
const sectionHeader = document.querySelector('.section-header');
document.getElementsByTagName('html')[0].style = '--main-header-height: ' + sectionHeader.offsetHeight + 'px';

if (document.querySelector('[data-header-sticky="true"]')) {
	offsetTopHeader = document.querySelector('[data-header-sticky="true"]').offsetTop;
}

document.addEventListener('scroll', (event) => {
	const btnNewsletterPopup = document.querySelector('.newsletter-popup_button');
	const stickyBottomMenu = document.querySelector('.sticky-bottom-mobile');
	const windowHeight = window.innerHeight;

	if (this.scrollY > windowHeight) {
		if (btnNewsletterPopup) {
			btnNewsletterPopup.classList.add('active');
		}

		if (stickyBottomMenu) {
			document.body.classList.add('sticky-menu-bottom-active');
		}
	} else {
		if (btnNewsletterPopup) {
			btnNewsletterPopup.classList.remove('active');
		}

		if (stickyBottomMenu) {
			document.body.classList.remove('sticky-menu-bottom-active');
		}
	}

	if (document.querySelector('[data-header-sticky="true"]')) {
		const headerMain = document.querySelector('.header-main');
		const headerMainContent = document.querySelector('.header-main__content');
		const classStickyOnTopColor = headerMain.getAttribute('data-group-color');

		if (this.scrollY >= offsetTopHeader) {
			sectionHeader.classList.add('sticky-header');

			if (document.body.classList.contains('index') && classStickyOnTopColor) {
				headerMainContent.classList.remove(classStickyOnTopColor);
			}
		} else {
			sectionHeader.classList.remove('sticky-header');

			if (document.body.classList.contains('index') && classStickyOnTopColor) {
				headerMainContent.classList.add(classStickyOnTopColor);
			}
		}
	}
});

var headerMainContainer = document.querySelector('.header-main');
var headerMainContent = document.querySelector('.header-main__content');

headerMainContainer.addEventListener('mouseover', headermainMouseOver);
headerMainContainer.addEventListener('mouseout', headermainMouseOut);

const headerMainColorSticky = headerMainContainer.getAttribute('data-group-color');

function headermainMouseOver() {
	if (!document.querySelector('.sticky-header') && document.body.classList.contains('index') && headerMainColorSticky) {
		headerMainContainer.classList.add('mouse-over');
		headerMainContent.classList.remove(headerMainColorSticky);
	}
}

function headermainMouseOut() {
	if (!document.querySelector('.sticky-header') && document.body.classList.contains('index') && headerMainColorSticky) {
		headerMainContainer.classList.remove('mouse-over');
		headerMainContent.classList.add(headerMainColorSticky);
	}
}

/**
 * FAQs group
 */

class GroupFaqs extends HTMLElement {
	constructor() {
		super();

		const faqSections = document.querySelectorAll('.tpt-faqs');

		faqSections.forEach((faqSection) => {
			const groupTitle = faqSection.querySelector('.faq-group-title').innerHTML;
			this.insertAdjacentHTML('beforeend', groupTitle);
		});
	}
}

customElements.define('tpt-group-faqs', GroupFaqs);

class FaqGroupItem extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.scrollToFaqs.bind(this));
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.scrollToFaqs();
		}
	}

	scrollToFaqs() {
		const faqSectionId = this.getAttribute('data-section-id');
		const faqTop = document.getElementById(faqSectionId).offsetTop;
		let fixOffsetTop = 0;

		if (window.innerWidth >= 1024) {
			fixOffsetTop = 60;
		}
		window.scrollTo({
			top: faqTop - fixOffsetTop,
			behavior: 'smooth',
		});
	}
}

customElements.define('faq-group-item', FaqGroupItem);

/**
 * View more
 */
class ViewMore extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.viewMore.bind(this));
	}

	viewMore() {
		this.classList.toggle('active');
		this.closest('.has-more').classList.toggle('active');
	}
}

customElements.define('tpt-viewmore', ViewMore);

/**
 * Close newsletter
 */
class CloseNewsletter extends HTMLElement {
	constructor() {
		super();

		if (!sessionStorage.getItem('closeNewsletter')) {
			this.closest('.newsletter-popup_button').style.display = 'block';
		}

		this.addEventListener('click', this.closeNewsletter.bind(this));
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.closeNewsletter();
		}
	}

	closeNewsletter() {
		this.closest('.newsletter-popup_button').style.display = 'none';
		sessionStorage.setItem('closeNewsletter', 'true');
	}
}

customElements.define('tpt-close-newsletter', CloseNewsletter);

/**
 * Update label sticky cart product page
 */

function updateStickyCartLabel() {
	if (document.querySelector('.sticky-button-cart') && document.querySelector('.main-product-section variant-selects')) {
		const productVariants = document.querySelectorAll('.main-product-section variant-selects fieldset.product-form__input');
		const variantLabelContainer = document.querySelectorAll('.sticky-cart_variants');

		variantLabelContainer.forEach((variantContent) => {
			variantContent.innerHTML = '';
		});

		productVariants.forEach((variant) => {
			const variantLabel = variant.querySelector('.form__label');
			variantLabelContainer.forEach((variantContent) => {
				variantContent.insertAdjacentHTML('beforeend', '<div class="variant-label">' + variantLabel.innerHTML + '</div>');
			});
		});
	}
}

updateStickyCartLabel();

/**
 * Toggle password
 */

if (!customElements.get('tpt-toggle-password')) {
	customElements.define(
		'tpt-toggle-password',
		class TptTogglePassword extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.togglePassword.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.togglePassword();
				}
			}

			togglePassword() {
				if (this.closest('.input-password').classList.contains('active')) {
					this.closest('.input-password').classList.remove('active');
					this.closest('.input-password').querySelector('input[type="text"]').setAttribute('type', 'password');
					return;
				} else {
					this.closest('.input-password').classList.add('active');
					this.closest('.input-password').querySelector('input[type="password"]').setAttribute('type', 'text');
					return;
				}
			}
		}
	);
}

/**
 * Slideshow scroll button
 */

class SlideShowScroll extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.slideScroll.bind(this));
		this.addEventListener('keypress', this.keyPress.bind(this));
	}

	keyPress(event) {
		if (event.key === 'Enter') {
			this.slideScroll();
		}
	}

	slideScroll() {
		const section = this.closest('.tpt-section');
		const scrollValue = section.offsetTop + section.offsetHeight;
		window.scrollTo({ top: scrollValue, behavior: 'smooth' });
	}
}

customElements.define('tpt-slideshow-scroll', SlideShowScroll);

/**
 * Section animation
 */

if (!customElements.get('tpt-animation-section')) {
	customElements.define(
		'tpt-animation-section',
		class TptAnimation extends HTMLElement {
			constructor() {
				super();

				this.elementRender = this.querySelector('[data-lazyload-element]');
			}

			connectedCallback() {
				const handleIntersection = (entries, observer) => {
					if (!entries[0].isIntersecting) return;
					observer.unobserve(this);

					setTimeout(() => {
						this.classList.add('tpt-animated');
					}, 500);
				};

				new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px -300px 0px' }).observe(this);
			}
		}
	);
}

/**
 * Toogle search mobile
 */

if (!customElements.get('tpt-search-drawer')) {
	customElements.define(
		'tpt-search-drawer',
		class TptSearchDrawer extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.toggleSearchMobile.bind(this));
			}

			toggleSearchMobile() {
				document.body.classList.add('boost-pfs-search-suggestion-mobile-open', 'boost-pfs-search-suggestion-open-body');
				setTimeout(() => {
					document.getElementById('boost-pfs-search-box-mobile').focus();
				}, 200);
			}
		}
	);
}
